/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { SessionIntent } from './SessionIntent';
import {
    SessionIntentFromJSON,
    SessionIntentFromJSONTyped,
    SessionIntentToJSON,
    SessionIntentToJSONTyped,
} from './SessionIntent';

/**
 * 
 * @export
 * @interface RunSummary
 */
export interface RunSummary {
    /**
     * 
     */
    runId: string;
    /**
     * 
     */
    startedAt: number | null;
    /**
     * 
     */
    captureCount: number;
    /**
     * 
     */
    latestCaptureEndTimestamp: number | null;
    /**
     * 
     */
    earliestEventTimestamp?: Date | null;
    /**
     * 
     */
    latestEventTimestamp?: Date | null;
    /**
     * 
     */
    eventCount?: number;
    /**
     * 
     */
    sessionIntent?: SessionIntent;
    /**
     * 
     */
    intentOverride?: SessionIntent | null;
}



/**
 * Check if a given object implements the RunSummary interface.
 */
export function instanceOfRunSummary(value: object): value is RunSummary {
    if ((!('runId' in (value as Record<string, any>)) && !('run_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['runId'] === undefined && (value as Record<string, any>)['run_id'] === undefined)) return false;
    if ((!('startedAt' in (value as Record<string, any>)) && !('started_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['startedAt'] === undefined && (value as Record<string, any>)['started_at'] === undefined)) return false;
    if ((!('captureCount' in (value as Record<string, any>)) && !('capture_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureCount'] === undefined && (value as Record<string, any>)['capture_count'] === undefined)) return false;
    if ((!('latestCaptureEndTimestamp' in (value as Record<string, any>)) && !('latest_capture_end_timestamp' in (value as Record<string, any>))) || ((value as Record<string, any>)['latestCaptureEndTimestamp'] === undefined && (value as Record<string, any>)['latest_capture_end_timestamp'] === undefined)) return false;
    return true;
}

export function RunSummaryFromJSON(json: any): RunSummary {
    return RunSummaryFromJSONTyped(json, false);
}

export function RunSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'runId': json['run_id'],
        'startedAt': json['started_at'],
        'captureCount': json['capture_count'],
        'latestCaptureEndTimestamp': json['latest_capture_end_timestamp'],
        'earliestEventTimestamp': json['earliest_event_timestamp'] === undefined ? undefined : json['earliest_event_timestamp'] === null ? null : (parseDateTime(json['earliest_event_timestamp'])),
        'latestEventTimestamp': json['latest_event_timestamp'] === undefined ? undefined : json['latest_event_timestamp'] === null ? null : (parseDateTime(json['latest_event_timestamp'])),
        'eventCount': json['event_count'] == null ? undefined : json['event_count'],
        'sessionIntent': json['session_intent'] == null ? undefined : SessionIntentFromJSON(json['session_intent']),
        'intentOverride': json['intent_override'] === undefined ? undefined : json['intent_override'] === null ? null : SessionIntentFromJSON(json['intent_override']),
    };
}

export function RunSummaryToJSON(json: any): RunSummary {
    return RunSummaryToJSONTyped(json, false);
}

export function RunSummaryToJSONTyped(value?: RunSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'run_id': value['runId'],
        'started_at': value['startedAt'],
        'capture_count': value['captureCount'],
        'latest_capture_end_timestamp': value['latestCaptureEndTimestamp'],
        'earliest_event_timestamp': value['earliestEventTimestamp'] == null ? value['earliestEventTimestamp'] : serializeDateTime(value['earliestEventTimestamp']),
        'latest_event_timestamp': value['latestEventTimestamp'] == null ? value['latestEventTimestamp'] : serializeDateTime(value['latestEventTimestamp']),
        'event_count': value['eventCount'],
        'session_intent': SessionIntentToJSON(value['sessionIntent']),
        'intent_override': SessionIntentToJSON(value['intentOverride']),
    };
}

